import { Mail, MapPin, Building2, Clock, Phone } from "lucide-react";
import { COMPANY } from "@/lib/company";
import { HoloBackground } from "@/components/HoloBackground";

export default function Contact() {
  return (
    <div className="vault-bg">
      <section className="relative overflow-hidden border-b border-white/8">
        <HoloBackground />
        <div className="relative mx-auto max-w-4xl px-4 py-16 sm:px-6 lg:px-8">
          <span className="overline mb-3 block">Kontakt</span>
          <h1 className="font-display text-3xl font-extrabold tracking-tight text-white sm:text-4xl lg:text-5xl">Kontaktujte nás</h1>
          <p className="mt-4 max-w-2xl text-slate-300">Radi vám pomôžeme s otázkami o produktoch, dostupnosti alebo spolupráci. Ozvite sa nám.</p>
        </div>
      </section>

      <section className="mx-auto max-w-4xl px-4 py-14 sm:px-6 lg:px-8">
        <div className="grid gap-5 sm:grid-cols-2">
          <div className="rounded-2xl border border-white/8 bg-vault-card p-6">
            <div className="mb-4 inline-flex h-11 w-11 items-center justify-center rounded-xl bg-gradient-to-br from-violet-glow/20 to-cyan-glow/20 text-cyan-300"><Building2 className="h-5 w-5" /></div>
            <h2 className="font-display text-lg font-bold text-white">Prevádzkovateľ</h2>
            <p className="mt-2 text-sm leading-relaxed text-slate-300">{COMPANY.name}<br />IČO: {COMPANY.ico}<br />IČ DPH: {COMPANY.icdph}<br />{COMPANY.register}</p>
          </div>
          <div className="rounded-2xl border border-white/8 bg-vault-card p-6">
            <div className="mb-4 inline-flex h-11 w-11 items-center justify-center rounded-xl bg-gradient-to-br from-violet-glow/20 to-cyan-glow/20 text-cyan-300"><MapPin className="h-5 w-5" /></div>
            <h2 className="font-display text-lg font-bold text-white">Adresa</h2>
            <p className="mt-2 text-sm leading-relaxed text-slate-300">{COMPANY.street}<br />{COMPANY.cityZip}<br />{COMPANY.country}</p>
          </div>
          <div className="rounded-2xl border border-white/8 bg-vault-card p-6" data-testid="contact-email">
            <div className="mb-4 inline-flex h-11 w-11 items-center justify-center rounded-xl bg-gradient-to-br from-violet-glow/20 to-cyan-glow/20 text-cyan-300"><Mail className="h-5 w-5" /></div>
            <h2 className="font-display text-lg font-bold text-white">E-mail</h2>
            <p className="mt-2 text-sm leading-relaxed text-slate-300"><a href={`mailto:${COMPANY.email}`} data-testid="contact-email-link" className="hover:underline">{COMPANY.email}</a></p>
          </div>
          <div className="rounded-2xl border border-white/8 bg-vault-card p-6" data-testid="contact-phone">
            <div className="mb-4 inline-flex h-11 w-11 items-center justify-center rounded-xl bg-gradient-to-br from-violet-glow/20 to-cyan-glow/20 text-cyan-300"><Phone className="h-5 w-5" /></div>
            <h2 className="font-display text-lg font-bold text-white">Telefón</h2>
            <p className="mt-2 text-sm leading-relaxed text-slate-300"><a href={`tel:${COMPANY.phone.replace(/\s/g, "")}`} data-testid="contact-phone-link" className="hover:underline">{COMPANY.phone}</a></p>
          </div>
          <div className="rounded-2xl border border-white/8 bg-vault-card p-6">
            <div className="mb-4 inline-flex h-11 w-11 items-center justify-center rounded-xl bg-gradient-to-br from-violet-glow/20 to-cyan-glow/20 text-cyan-300"><Clock className="h-5 w-5" /></div>
            <h2 className="font-display text-lg font-bold text-white">Odpovedáme</h2>
            <p className="mt-2 text-sm leading-relaxed text-slate-300">Zvyčajne do 1–2 pracovných dní.</p>
          </div>
        </div>
      </section>
    </div>
  );
}
